(function () {
  if (window.customElements && customElements.get('fan-wall')) return;

  class FanWall extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fan-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-fan-prev]');
      this.nextBtn = this.querySelector('[data-fan-next]');
      this.modal = this.querySelector('[data-fan-modal]');
      this.modalImage = this.querySelector('[data-fan-modal-image]');
      this.modalCaption = this.querySelector('[data-fan-modal-caption]');
      this.modalUser = this.querySelector('[data-fan-modal-user]');
      this.onScroll = this.updateArrows.bind(this);
      this.onClick = this.handleClick.bind(this);
      this.onVisibility = this.handleVisibility.bind(this);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoMs = 4000;
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.addEventListener('click', this.onClick);
      this.addEventListener('mouseenter', () => {
        this.hovering = true;
        this.stopAuto();
      });
      this.addEventListener('mouseleave', () => {
        this.hovering = false;
        this.resumeAuto();
      });
      this.addEventListener('focusin', () => this.stopAuto());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.resumeAuto();
      });
      document.addEventListener('visibilitychange', this.onVisibility);
      if (this.modal) {
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.closeModal();
        });
        this.modal.addEventListener('close', () => {
          if (this.lastFocus) this.lastFocus.focus();
          this.resumeAuto();
        });
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.scrollByCard(-1);
          this.kickAuto();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.scrollByCard(1);
          this.kickAuto();
        });
      }
      this.updateArrows();
      this.onLoad = () => this.resumeAuto();
      requestAnimationFrame(this.onLoad);
      window.addEventListener('load', this.onLoad);
    }

    disconnectedCallback() {
      this.stopAuto();
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('load', this.onLoad);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    handleVisibility() {
      if (document.hidden) this.stopAuto();
      else this.resumeAuto();
    }

    startAuto() {
      this.stopAuto();
      if (!this.hasAttribute('data-autoplay')) return;
      if (!this.track || (this.reducedMotion && this.reducedMotion.matches)) return;
      if (this.track.scrollWidth - this.track.clientWidth <= 2) return;
      this.autoTimer = window.setInterval(() => this.autoAdvance(), this.autoMs);
    }

    stopAuto() {
      if (!this.autoTimer) return;
      window.clearInterval(this.autoTimer);
      this.autoTimer = null;
    }

    resumeAuto() {
      if (this.hovering || document.hidden) return;
      if (this.modal && this.modal.open) return;
      this.startAuto();
    }

    kickAuto() {
      if (this.hovering || (this.modal && this.modal.open)) return;
      this.startAuto();
    }

    autoAdvance() {
      if (!this.track || document.hidden || (this.modal && this.modal.open)) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxScroll <= 2) return;
      if (this.track.scrollLeft >= maxScroll - 2) {
        this.track.scrollTo({ left: 0, behavior: 'auto' });
        return;
      }
      this.scrollByCard(1);
    }

    handleClick(event) {
      if (event.target.closest('[data-fan-close]')) {
        this.closeModal();
        return;
      }
      const card = event.target.closest('[data-fan-open]');
      if (!card || !this.contains(card)) return;
      this.openModal(card);
    }

    openModal(card) {
      if (!this.modal) return;
      const captionNode = card.querySelector('.fan-wall__caption');
      const caption = captionNode ? captionNode.textContent.trim() : '';
      const full = card.getAttribute('data-fan-full');
      if (this.modalImage) {
        if (full) {
          this.modalImage.src = full;
          this.modalImage.alt = caption;
          this.modalImage.hidden = false;
        } else {
          this.modalImage.removeAttribute('src');
          this.modalImage.alt = '';
          this.modalImage.hidden = true;
        }
      }
      if (this.modalCaption) {
        this.modalCaption.textContent = caption;
        this.modalCaption.hidden = caption === '';
      }
      if (this.modalUser) {
        const user = card.getAttribute('data-fan-user') || '';
        this.modalUser.textContent = user;
        this.modalUser.hidden = user === '';
      }
      this.lastFocus = card;
      this.stopAuto();
      if (typeof this.modal.showModal === 'function') {
        if (!this.modal.open) this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }
    }

    closeModal() {
      if (!this.modal) return;
      if (typeof this.modal.close === 'function' && this.modal.open) this.modal.close();
      else this.modal.removeAttribute('open');
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.fan-wall__card');
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 12;
      const amount = ((card ? card.getBoundingClientRect().width : this.track.clientWidth) + gap) * direction;
      this.track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= maxScroll - 2;
      const noOverflow = maxScroll <= 2;
      if (this.prevBtn) this.prevBtn.disabled = atStart || noOverflow;
      if (this.nextBtn) this.nextBtn.disabled = atEnd || noOverflow;
    }
  }

  customElements.define('fan-wall', FanWall);
})();
